<template>
	<div class="wrapper blank-wrapper">
		<router-view />
		<loading :active.sync="$store.state.loading.status" />
	</div>
</template>

<script>
export default {
    
};
</script>

